import { render, staticRenderFns } from "./PaymentBalance.vue?vue&type=template&id=7b5c7c04&scoped=true"
import script from "./PaymentBalance.vue?vue&type=script&lang=js"
export * from "./PaymentBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5c7c04",
  null
  
)

export default component.exports